import dayjs from 'dayjs';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/en';
import 'dayjs/locale/fr-ch';
import 'dayjs/locale/it-ch';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';

export default (localeCode: string) => {
  dayjs.locale(localeCode);
  dayjs.extend(customParseFormat);
  dayjs.extend(localizedFormat);
  dayjs.extend(weekOfYear);

  const dateFormatter = (date: string | number | dayjs.Dayjs | Date | undefined, format?: string | { locale?: string | undefined; format?: string | undefined; utc?: boolean | undefined; } | string[] | undefined, strict?: boolean | undefined): dayjs.Dayjs | undefined => {
    if (date === undefined || date === null) {
      return undefined;
    }
    return dayjs(date, format, strict);
  };

  Object.keys(dayjs).forEach((key) => {
    (dateFormatter as any)[key] = (dayjs as any)[key];
  });
  dateFormatter.now = () => dayjs();
  dateFormatter.isDateObject = (obj: any) => dayjs.isDayjs(obj);

  // Override default behaviour of returning "now" when passing undefined
  return dateFormatter as unknown as typeof dayjs & {now: ()=>dayjs.Dayjs, isDateObject: (obj: any)=> boolean};
};
